import * as React from 'react';

import { AvatarSize } from 'components/Avatar';
import MediaObject from 'components/MediaObject';
import Row from 'components/Row';
import Text from 'components/Text';
import TextWithSubtext from 'components/TextWithSubtext';
import { MediaObjectGutter } from 'components/MediaObject';

import './AvatarWithText.scss';

type Props = {
  avatar: React.ReactElement;
} & OptionalProps;

export type OptionalProps = {
  avatarSize?: AvatarSize;
  icon?: React.ReactElement;
  level?: 'primary' | 'secondary';
  subtext?: string | React.ReactElement;
  subtle?: boolean;
  title?: string | React.ReactElement;
  gutter?: MediaObjectGutter;
};

export default function AvatarWithText({
  avatar,
  avatarSize,
  gutter = 'xsmall' as MediaObjectGutter,
  icon,
  level,
  subtext,
  subtle,
  title,
}: Props) {
  const avatarWithProps = React.cloneElement(avatar, { size: avatarSize || 'medium' });

  if (level === 'primary') {
    return (
      <Text align="center" element="div" className="AvatarWithText">
        <Row size="small">
          <div className="AvatarWithText-avatar">
            {avatarWithProps}
            {icon && <div className="AvatarWithText-avatar-icon">{icon}</div>}
          </div>
        </Row>
        <Text element="h2" size="xlarge" truncate>
          {title}
        </Text>
        <Text color="thunder" size="medium">
          {subtext}
        </Text>
      </Text>
    );
  }

  return (
    <MediaObject center gutter={gutter} className="AvatarWithText">
      {avatarWithProps}
      <TextWithSubtext subtext={subtext} subtle={subtle}>
        {title}
      </TextWithSubtext>
    </MediaObject>
  );
}

AvatarWithText.defaultProps = {
  level: 'secondary',
};
